(function () {
    // 注册组件
    SR.modules.extend('debug', debug);
    
    function debug() {
        this.clearStorage = function() {
            SR.data.SRStorage = {};
            localStorage.removeItem('SRStorage');
        }

        this.testAllScenes = function() {
            askAll([
                '讲个笑话',
                '中国石油',
                '中国石油怎么样',
                '中国石油的新闻',
                '中国石油的公告',
                '中国石油的研报',
                '热门板块',
                '今日涨幅榜',
                '跌幅大的股票',
                'macd黄金交叉的股票',
                '换手率高的股票',
                '资金流入大的股票',
                '资金流出大的股票',
                '主力购买的股票有哪些',
                '大单卖出的股票有哪些',
                '医药概念股',
                '什么区域的股票好',
                '推荐几个好的行业股票',
                '短线股票',
                '有哪些股票可以逢低买入',
                '机构关注的股票',
                '龙头股有哪些',
                '推荐几只新股',
                '智能组合',
                '中国石油资金',
                '预测中国石油',
                '市盈率大于10的股票',
                '盾安环境的相似K线',
                '大盘风向',
                '今日要闻',

                '斩仓',
                '十字线',
                '如何开通创业板',
                '如何申购新股',
                '附近的长江证券',
                '尖山病',
                '什么是资产重组',
                '个股期权行权的流程',

                '万科的公司名称',
                '万科的注册资本',
                '万科的每股收益',
                '万科的流通股本',
                '万科的概念',
                '万科的股东',
                '万科的分红融资',
                '万科的公司高管',
                '万科的投资评级',
                '万科盈利预测',
                '科大讯飞的市场表现',
                '买入万科100手',

                '投资日历',
                '5G的新闻',
                '万科的动态',
                '自选股动态',
                '热门股票',
                '万科的大宗交易',
                '万科的融资融券',
                '华森制药龙虎榜',
                '行业板块资金流入',
                '万科的公司简介',
                '万科的筹码分布',
                '龙虎榜股票',
                '万科机构持仓',
                '美的集团解禁',
                '大宗交易溢价',
                '融资买入高的股票',
                '万科的营业收入',
                '港资买入股票',
                '质押比例高的股票',
                '即将解禁的股票',
                '推荐三只股票',
                '热门资讯',
            ]);
        }

        this.debug = function() {
            var scrollAnimateDuration = SR.data.scrollAnimateDuration;
            var askId = 'askId-' + Date.now();
            var urlSearch = location.search && location.search.replace('?', '');
            var analyticsCookies = Cookies.get('ac');
            if (analyticsCookies) {
                analyticsCookies = JSON.parse(analyticsCookies);
            }
            SR.dom.$wrapper.append(
                template('ask', {
                    id: askId,
                    msg: SR.command.debug,
                    avatar: SR.data.userInfo.userAvatar,
                })
            );
            $.ajax({
                method: 'GET',
                timeout: SR.data.xhrTimeout,
                url: '/debug',
                data:
                    '&guid=' +
                    SR.data.deviceInfo.guid +
                    '&xua=' +
                    encodeURIComponent(SR.data.deviceInfo.xua) +
                    '&j=' +
                    analyticsCookies.jsid +
                    '&u=' +
                    SR.data.userInfo.uid +
                    '&' +
                    urlSearch
            })
            .done(function(data) {
                var templateHTML;
                var answerDomId = 'answerId-' + Date.now();
                if (data.ret === 0) {
                    var info = data.info;
                    info.host = location.hostname;
                    info.location = SR.data.location.longitude + '_' + SR.data.location.latitude;
                    templateHTML = template('debug', {
                        id: answerDomId,
                        title: ':D',
                        info: data.info
                    });
                    SR.dom.$wrapper.append(templateHTML);
                    SR.dom.$scrollWrap.stop(false, true).animate(
                        {
                            scrollTop: $('.content-wrapper').height()
                        },
                        scrollAnimateDuration
                    );
                } 
            })
            .fail(function() {
            })
            .always(function() {
            });
        }
    }
}());